import { createUseStyles } from 'react-jss';
import { FontWeights } from '@picsart/rc/fonts';

import { ITheme } from 'types';

const commonStyles = {
  pointerEvents: 'all',
  display: 'grid',
  gridAutoFlow: 'column',

  width: 124,
  height: 40,
  background: 'var(--layout-bg-color)',
  borderRadius: 'var(--layout-border-radius)',
};

const useStyles = createUseStyles(({ spacings, colors }: ITheme) => ({
  root: {
    position: 'relative',
    gap: spacings.s4,
    padding: spacings.s2,
    ...commonStyles,
  },
  label: {
    display: 'block',
    height: '100%',
  },
  input: {
    display: 'block',
    width: '100%',
    height: '100%',
    fontWeight: FontWeights.SemiBold,
    fontSize: 14,
    color: colors.texts.tint1,
    textAlign: 'center',
  },
  hasToggler: {
    width: 'auto',
  },
  withToggler: {
    position: 'absolute',
    bottom: `calc(100% + ${spacings.s4})`,
    left: '-100%',
    gap: spacings.s4,
    padding: spacings.s2,
    ...commonStyles,
  },
}));

export default useStyles;
